// @flow

/**
 * fetchQuery с таймаутом: по истечении времени отменяется подписка на Observable,
 * что в react-relay-network-modern прерывает HTTP (AbortController).
 */
export function fetchQueryWithTimeout(
	environment: any,
	taggedNode: any,
	variables: Object,
	timeoutMs: number,
	timeoutMessage: string = 'Превышено время ожидания',
): Promise<any> {
	const { createOperationSelector, getRequest } = environment.unstable_internal;
	const query = getRequest(taggedNode);
	const operation = createOperationSelector(query, variables);
	const observable = environment
		.execute({ operation })
		.map(() => environment.lookup(operation.fragment).data);

	return new Promise((resolve, reject) => {
		let settled = false;
		let subscription;
		const timeoutId = setTimeout(() => {
			if (!settled) {
				settled = true;
				if (subscription) {
					subscription.unsubscribe();
				}
				reject(new Error(timeoutMessage));
			}
		}, timeoutMs);
		subscription = observable.subscribe({
			next: data => {
				if (!settled) {
					settled = true;
					clearTimeout(timeoutId);
					resolve(data);
				}
			},
			error: err => {
				if (!settled) {
					settled = true;
					clearTimeout(timeoutId);
					reject(err);
				}
			},
			complete: () => {
				if (!settled) {
					settled = true;
					clearTimeout(timeoutId);
					reject(new Error('Пустой ответ сервера'));
				}
			},
		});
	});
}



// WEBPACK FOOTER //
// src/lib/fetchQueryWithTimeout.js